<template>
  <div>
    <table
      v-if="vx_billInfo"
      class="table table-striped jambo_table bulk_action"
    >
      <thead>
        <tr class="headings fontSize14">
          <th v-for="head in HEAD" :key="head" class="column-title word_center">
            {{ head }}
          </th>
          <th v-if="vx_billInfo.cars !== 1" class="column-title word_center">
            取消
          </th>
        </tr>
      </thead>
      <tbody v-if="driver.length">
        <tr
          v-for="row in driver"
          class="pointer fontSize14"
          style="text-align: center"
          :key="row.driverCallNumber"
        >
          <td class="text-black">{{ row.driverCallNumber }}</td>
          <td class="text-black">{{ row.driverName }}</td>
          <td class="text-black">{{ row.driverPhone }}</td>
          <td class="text-black">{{ row.driverNote }}</td>
          <td class="text-black">{{ formatDate(row.createdAt) }}</td>
          <td class="text-black">
            <button
              v-if="setMatchBtn(row)"
              class="mybtnstyle btn-default"
              :class="row.driverState === 1 ? 'btn-default' : 'btn-danger'"
              @click="deal(row)"
            >
              {{ row.driverState === 1 ? '已配對' : '配對' }}
            </button>
          </td>
          <td v-if="vx_billInfo.cars !== 1">
            <button class="mybtnstyle btn-default" @click="cancel(row)">
              取消
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { reqDeal, reqCancel } from '@/api/reservation'
import { Notification, MessageBox } from 'element-ui'
import { mapState, mapActions } from 'vuex'
import dayjs from 'dayjs'
import { carState } from '@/constants/tableHead'

export default {
  methods: {
    ...mapActions('reserveModal', {
      vx_fetchOrderDetail: 'fetchOrderDetail',
    }),
    async updateDeal(payload) {
      try {
        const { success } = await reqDeal({
          reservationId: this.vx_billInfo.orderId,
          driverId: payload.driverId,
          teamId: payload.teamId,
          reservationCarStateId: payload.reservationCarStateId,
          driverState: 1,
        })
        if (success) {
          Notification({
            title: '更新成功',
            type: 'success',
          })
          /* 預約單 */
          this.vx_fetchOrderDetail()
          /* 叫車紀錄總查詢 */
        } else {
          Notification({
            title: '失敗',
            message: '更新失敗，請稍後再試',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '失敗',
          message: '更新失敗，請稍後再試',
          type: 'error',
        })
        console.error(e)
      }
    },
    async updateCancel(payload) {
      try {
        const { success } = await reqCancel({
          reservationId: this.vx_billInfo.orderId,
          driverId: payload.driverId,
        })
        if (success) {
          Notification({
            title: '取消成功',
            type: 'success',
          })
          this.vx_fetchOrderDetail()
        } else {
          Notification({
            title: '失敗',
            message: '取消失敗，請稍後再試',
            type: 'error',
          })
        }
      } catch (e) {
        Notification({
          title: '失敗',
          message: '取消失敗，請稍後再試',
          type: 'error',
        })
        console.error(e)
      }
    },
    deal(row) {
      if (row.driverState !== 1) return // 已配對不重複觸發
      const dealPayload = {
        driverId: row.driverId,
        teamId: row.driverTeamId,
        reservationCarStateId: row.reservationCarStateId,
      }
      const method = this.vx_billInfo.callMethod
      if (method === 0 || method === 3 || method === 4) {
        MessageBox.confirm(
          '由於是app、line預約，所以有先與乘客確認嗎?',
          '提示',
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.updateDeal(dealPayload)
        })
      } else {
        this.updateDeal(dealPayload)
      }
    },
    async cancel(row) {
      const cancelPayload = { driverId: row.driverId }
      const method = this.vx_billInfo.callMethod
      if (method === 0 || method === 3 || method === 4) {
        if (!confirm('由於是app、line預約，所以有先與乘客確認嗎?')) return
        MessageBox.confirm(
          '由於是app、line預約，所以有先與乘客確認嗎?',
          '提示',
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        ).then(() => {
          this.updateCancel(cancelPayload)
        })
      } else {
        this.updateCancel(cancelPayload)
      }
    },
    formatDate(date) {
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    setMatchBtn(rowData) {
      // line不論是配對還是已配對都顯示
      if (this.vx_billInfo.callMethod === 3) return true
      return rowData.driverState !== 1
    },
  },
  computed: {
    ...mapState('reserveModal', {
      vx_billInfo: 'billInfo',
      vx_driverState: 'driverState',
    }),
    driver() {
      if (!this.vx_driverState.length) return []
      return [...this.vx_driverState].sort((a, b) => {
        if (dayjs(a.createdAt).isSame(dayjs(b.createdAt))) {
          return 0
        } else {
          return dayjs(a.createdAt).isBefore(dayjs(b.createdAt)) ? -1 : 1
        }
      })
    },
  },
  created() {
    this.HEAD = carState
  },
}
</script>

<style scoped>
.text-black {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/reserveModal/CarStateTable.vue